<template>
  <div class="g-wrapper g-vertical-block">
    <div class="g-main-wrapper g-vertical-block">
      <keep-alive :max="10">
        <router-view :key="$route.path" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss"></style>
